var map = {
	"./E@2x.png": 44,
	"./ENE@2x.png": 45,
	"./ESE@2x.png": 46,
	"./N@2x.png": 47,
	"./NE@2x.png": 48,
	"./NNE@2x.png": 49,
	"./NNW@2x.png": 50,
	"./NW@2x.png": 51,
	"./S@2x.png": 52,
	"./SE@2x.png": 53,
	"./SSE@2x.png": 54,
	"./SSW@2x.png": 55,
	"./SW@2x.png": 56,
	"./W@2x.png": 57,
	"./WNW@2x.png": 58,
	"./WSW@2x.png": 59
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43;